<template>
  <div class="tpl">
    <van-nav-bar title="爆款商品" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div v-for="item in goodsList" :key="item.id">
      <a
        :href="item.url"
        style="background-color:#fff; padding:10px; margin-bottom:10px;display:block"
      >
        <img :src="item.image" style="width:100%" />

        <div style="font-size:14px">
          ¥
          <span style="color:red; font-size:24px; padding-left:6px">{{item.price}}</span>
          <del style="padding-left:20px">¥ {{item.oldPrice}}</del>
        </div>
        <div style="font-size:16px;">{{item.title}}</div>
      </a>
    </div>
    <div style="height:60px;"></div>
    <DPtabbar active="4"></DPtabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
import DPtabbar from "@/components/TabBar.vue";
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "orderList",
  components: {
    DPtabbar,
  },
  data() {
    return {
      goodsList: [
        {
          image:
            "https://oss.lwljuyang.com/20200722/FILE99722d69f91e4b79abdec770097aaef7.jpg",
          title: "物语本色竹浆抽纸10包装",
          price: "9.90",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221017210000674474&isshare=1",
          oldPrice: "19.90",
        },
        {
          image:
            "https://oss.lwljuyang.com/20200722/FILEe5d8c7be2ff54e0da233ca449aa68871.png",
          title: "兴谷 若羌红枣粥枣新疆特产2斤散装 ",
          price: "9.90",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221048250000674554&isshare=1",
          oldPrice: "19.90",
        },

        {
          image:
            "https://oss.lwljuyang.com/20200722/FILE95ef648e957c4b2ca176746e1d8582d8.jpg",
          title: "罗莱花漾人生水洗棉夏被150*200cm",
          price: "39.90",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221029100000674493&isshare=1",
          oldPrice: "200.00",
        },
        {
          image:
            "https://oss.lwljuyang.com/20200722/FILE2dd09a1f306d48c58ffa6dca45b5181e.jpg",
          title: "梓濠（ZiHao）一次性口罩无纺布含熔喷布三层防护口罩防尘透气",
          price: "22.90",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221042110000674541&isshare=1",
          oldPrice: "44.90",
        },

        {
          image:
            "https://oss.lwljuyang.com/20200723/FILE77a106983d724fbc9202e96c1a5ab6ac.jpg",
          title: "日本技术Tenou消毒杀菌纸100抽/包（6包）",
          price: "44.80",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221045540000674547&isshare=1",
          oldPrice: "66.80",
        },
        {
          image:
            "https://oss.lwljuyang.com/20200722/FILEb8f07980299541159470309286610790.jpg",
          title: "活性炭牙膏竹炭去黄牙垢亮白网红口臭清新口气",
          price: "15.80",
          url:
            "https://c.m.lwljuyang.com/h5/#/Logistics?productUuid=SKU221044140000674543&isshare=1",
          oldPrice: "99.90",
        }
      ],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getList() {
     
      this.$http
        .get(this.GLOBAL.URL + "/goodsList.json",
          
          {
            params: {},
            headers: {}
          }
        )
        .then(response => {
            let data = response;
          this.goodsList = data;
          console.log(data);
        });
    }
  },
  mounted() {
    //   this.getList();
  },
};
</script>
<style lang="scss" scoped>
.tpl {
  height: 100%;
  background-color: #f6f6f6;
  text-align: left;
}
.group {
  background-color: #fff;
  margin: 10px;
  border-radius: 10px;
  padding: 10px;
  .goods {
    .g {
      margin-top: 5px;
      display: flex;
      .l {
        width: 100px;
      }
      .r {
        flex-grow: 1;
        margin-left: 20px;
        .title {
          line-height: 25px;
          height: 50px;
          overflow: hidden;
        }
        .attr_price {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>